
/* injects from baggage-loader */

import ShortUniqueId from 'short-unique-id';

const uid = new ShortUniqueId();

export function genSecureHex(limit=13){
  return uid.randomUUID(limit);
}



// WEBPACK FOOTER //
// ./src/app/core/services/secure-random.js